export const getReasonTypesByLocation = (clinicsList, location) => {
  const matchingClinics =
    clinicsList?.filter((clinic) => clinic.location === location) || [];

  const reasonTypes = matchingClinics.flatMap(
    (clinic) =>
      clinic.appointmentSuggestions
        ?.flatMap((suggestion) => suggestion.type || [])
        .filter(Boolean) || []
  );

  const unique = [...new Set(reasonTypes)];
  return unique.sort((a, b) => a.localeCompare(b));
};
